import { Link, useNavigate } from 'react-router-dom';
import ProfileGoBackButton from '../ProfileGoBackButton/ProfileGoBackButton';
import './EditProfile.css';
import { DEFAULT_MAX_IMG_SIZE, IMG_PLACEHOLDER_PRODUCT, PROFILE_CHANGE_EMAIL_LINK, PROFILE_CHANGE_PASSWORD_LINK, PROFILE_MAIN_LINK } from '../../../assets/utils/constants';
import mainAppApi from '../../../assets/api/MainAppApi';
import { useContext, useState } from 'react';
import { UserContext } from '../../../assets/contexts/userContext';
import useAutoDismissError from '../../../assets/hooks/useAutoDismissError';
import { parseApiError } from '../../../assets/utils/utils';
import Input from '../../Input/Input';
import MiniPreloader from '../../MiniPreloader/MiniPreloader';

function EditProfile() {
    const { user, setUser } = useContext(UserContext)
    const [avatarError, showAvatarError] = useAutoDismissError();
    const navigate = useNavigate()
    const [values, setValues] = useState({
        avatar: user.avatar ? user.avatar : null,
        name: user.name,
    })
    const [valuesValidity, setValuesValidity] = useState({
        avatar: {},
    })

    const [preloaders, setPreloaders] = useState({
        submit: false,
        imageOnLoad: false,
    })

    function handleAvatarChange(e) {
        const input = e.target;
        const file = input.files[0];

        if (file && file.size / 1000000 >= DEFAULT_MAX_IMG_SIZE) {
            setValuesValidity((prevValue) => ({
                ...prevValue,
                avatar: { ...prevValue.avatar, errorMessage: "", validState: false },
            }));
            return;
        }

        let data = new FormData();
        data.append("image", file);
        setPreloaders(prevValue => ({
            ...prevValue,
            imgOnLoad: true,
        }))
        mainAppApi
            .uploadImage({ data, type: 'avatars' })
            .then((res) => {
                setValues((prevValue) => ({
                    ...prevValue,
                    avatar: res,
                }));
                setValuesValidity((prevValue) => ({
                    ...prevValue,
                    avatar: { errorMessage: "", validState: true, isChanged: true },
                }));
            })
            .catch((err) => {
                showAvatarError(parseApiError(err));
            })
            .finally(() => {
                setPreloaders(prevValue => ({
                    ...prevValue,
                    imgOnLoad: false,
                }))
            });
    }

    function handleChange(e) {
        const input = e.target;
        const name = input.name;
        let value = input.value;

        setValues((prevValue) => ({
            ...prevValue,
            [name]: value,
        }));
    }

    const isNameChanged = values.name.trim() !== user.name.trim();
    const isAvatarChanged = (values.avatar?._id !== user.avatar?._id);

    const isSubmitInactive = (
        values.name.trim() === "" || // имя пустое
        (!isNameChanged && !isAvatarChanged) // нет изменений ни в имени, ни в аватаре
    );



    function handleSubmit() {
        setPreloaders(prevValue => ({
            ...prevValue,
            submit: true,
        }))
        mainAppApi.editPersonalData({
            name: values.name,
            avatar: values.avatar ? values.avatar._id : null,
            is_notifications_enabled: user.is_notifications_enabled,
        })
            .then((res) => {
                console.log(res)
                setUser(prevValue => ({
                    ...prevValue,
                    name: values.name,
                    avatar: values.avatar,
                }))
                setPreloaders(prevValue => ({
                    ...prevValue,
                    submit: false,
                }))
            })
            .catch((err) => {
                console.log(err)
            })
    }
    return (
        <div className='edit-profile'>
            <div className='edit-profile__heading'>
                <ProfileGoBackButton
                    onClick={() => {
                        navigate(`/${PROFILE_MAIN_LINK}`)
                    }}
                />
                <div className='edit-profile__heading-title-box' >
                    <p className='edit-profile__heading-title'>Profile</p>
                </div>
            </div>

            <label
                className="edit-profile__avatar"
                htmlFor={'edit-profile__avatar-input'}
            >
                <input onChange={handleAvatarChange} type="file" className="edit-profile__avatar-input" id='edit-profile__avatar-input' accept='image/png, image/jpeg'></input>
                {preloaders.imgOnLoad ?
                    <div className='edit-profile__avatar-input-loader'>
                        <MiniPreloader />
                    </div>
                    : null}
                {values.avatar ? <img key={values.avatar.urls.orig} className='edit-profile__avatar-img' src={values.avatar.urls.orig} alt='' /> : <img className='edit-profile__avatar-img' src={IMG_PLACEHOLDER_PRODUCT} alt='' />}
                <div className='edit-profile__avatar-icon'>
                    <svg width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.66634 3V3.6C4.86695 3.6 5.05429 3.49974 5.16557 3.33282L4.66634 3ZM5.60385 1.59373L5.10462 1.26091L5.10462 1.26091L5.60385 1.59373ZM10.3955 1.59373L10.8947 1.26091L10.8947 1.26091L10.3955 1.59373ZM11.333 3L10.8338 3.33282C10.9451 3.49974 11.1324 3.6 11.333 3.6V3ZM9.99967 8H9.39967C9.39967 8.7732 8.77287 9.4 7.99967 9.4V10V10.6C9.43561 10.6 10.5997 9.43594 10.5997 8H9.99967ZM7.99967 10V9.4C7.22648 9.4 6.59967 8.7732 6.59967 8H5.99967H5.39967C5.39967 9.43594 6.56373 10.6 7.99967 10.6V10ZM5.99967 8H6.59967C6.59967 7.2268 7.22648 6.6 7.99967 6.6V6V5.4C6.56373 5.4 5.39967 6.56406 5.39967 8H5.99967ZM7.99967 6V6.6C8.77287 6.6 9.39967 7.2268 9.39967 8H9.99967H10.5997C10.5997 6.56406 9.43561 5.4 7.99967 5.4V6ZM4.66634 3L5.16557 3.33282L6.10308 1.92655L5.60385 1.59373L5.10462 1.26091L4.16711 2.66718L4.66634 3ZM6.71325 1V1.6H9.2861V1V0.4H6.71325V1ZM10.3955 1.59373L9.89627 1.92655L10.8338 3.33282L11.333 3L11.8322 2.66718L10.8947 1.26091L10.3955 1.59373ZM9.2861 1V1.6C9.53129 1.6 9.76026 1.72254 9.89627 1.92655L10.3955 1.59373L10.8947 1.26091C10.5362 0.723062 9.93251 0.4 9.2861 0.4V1ZM5.60385 1.59373L6.10308 1.92655C6.23909 1.72254 6.46806 1.6 6.71325 1.6V1V0.4C6.06684 0.4 5.46319 0.723062 5.10462 1.26091L5.60385 1.59373ZM14.6663 5.66667H14.0663V10.3333H14.6663H15.2663V5.66667H14.6663ZM11.9997 13V12.4H3.99967V13V13.6H11.9997V13ZM1.33301 10.3333H1.93301V5.66667H1.33301H0.733008V10.3333H1.33301ZM3.99967 13V12.4C2.85829 12.4 1.93301 11.4747 1.93301 10.3333H1.33301H0.733008C0.733008 12.1375 2.19554 13.6 3.99967 13.6V13ZM14.6663 10.3333H14.0663C14.0663 11.4747 13.1411 12.4 11.9997 12.4V13V13.6C13.8038 13.6 15.2663 12.1375 15.2663 10.3333H14.6663ZM11.9997 3V3.6C13.1411 3.6 14.0663 4.52528 14.0663 5.66667H14.6663H15.2663C15.2663 3.86254 13.8038 2.4 11.9997 2.4V3ZM3.99967 3V2.4C2.19554 2.4 0.733008 3.86254 0.733008 5.66667H1.33301H1.93301C1.93301 4.52528 2.85829 3.6 3.99967 3.6V3ZM3.99967 3V3.6H4.66634V3V2.4H3.99967V3ZM11.9997 3V2.4H11.333V3V3.6H11.9997V3Z" fill="white" />
                    </svg>

                </div>
            </label>
            <div className='edit-profile__inputs'>
                <div className='edit-profile__input-item'>
                    <p className='edit-profile__input-title'>Full Name</p>
                    <div className='edit-profile__input-box'>
                        <Input
                            value={values.name}
                            handleChange={handleChange}
                            name={"name"}
                            placeholder={'Enter your name'}
                        />
                    </div>
                </div>
                <div className='edit-profile__update-btns'>
                    {/* TODO: ADD CORRECT LINKS */}
                    <Link to={`/${PROFILE_MAIN_LINK}/${PROFILE_CHANGE_EMAIL_LINK}`} className='edit-profile__update-btn'>
                        Update Email
                    </Link>
                    <Link to={`/${PROFILE_MAIN_LINK}/${PROFILE_CHANGE_PASSWORD_LINK}`} className='edit-profile__update-btn'>
                        Update Password
                    </Link>
                </div>
            </div>

            <button className={`edit-profile__submit ${isSubmitInactive || preloaders.submit ? 'edit-profile__submit_inactive' : ''}`} type='button' onClick={handleSubmit}>
                {preloaders.submit ? <MiniPreloader isLinkColor={true} /> : 'Apply changes'}
            </button>


        </div>
    );
}

export default EditProfile